class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble--mobile',
        section: 'cart-icon-bubble--mobile',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();

        var freedelivery = parsedState.sections[Object.keys(parsedState.sections)[0]];
        if(document.getElementById('cart-page-free-delivery')){
          freedelivery = freedelivery.split('<div id="cart-page-free-delivery" class="free-delivery-bar">').pop();
          freedelivery = freedelivery.split('<div class="free-delivery-bar__end hide"></div>').shift();
          if(document.getElementById('cart-page-free-delivery')) document.getElementById('cart-page-free-delivery').innerHTML = freedelivery;
          if(document.getElementById('product-page-free-delivery')) document.getElementById('product-page-free-delivery').innerHTML = freedelivery;
        }
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};
// ==== Garantiknapp + egen hantering av +/–/ta-bort i DRAWER ====
(() => {
  if (window.__ejWarrantyV3) return;
  window.__ejWarrantyV3 = true;

  const WARRANTY_VARIANT_ID = 51865590399313;
  const routes = window.routes || {};
  const ADD_URL  = routes.cart_add_url || '/cart/add.js';
  const CART_URL = routes.cart_url     || '/cart';

  function clearErrors() {
    [document.getElementById('CartDrawer-CartErrors'),
     document.getElementById('cart-errors')].forEach(el => el && (el.textContent = ''));
  }
  function setError(msg) {
    const el = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
    if (el) el.textContent = msg; else alert(msg);
  }

  async function refreshDrawer() {
    const res = await fetch(`${CART_URL}?sections=cart-drawer,cart-icon-bubble`, { credentials:'same-origin', cache:'no-store' });
    if (!res.ok) { location.reload(); return; }
    const data = await res.json();

    // Byt BARA innehållet i #CartDrawer (behåll komponenten så den förblir öppen)
    const current = document.querySelector('#CartDrawer');
    if (current && data['cart-drawer']) {
      const tmp = document.createElement('div');
      tmp.innerHTML = data['cart-drawer'];
      const incoming = tmp.querySelector('#CartDrawer');
      if (incoming) current.innerHTML = incoming.innerHTML;
    }

    // Uppdatera cart-bubblan
    if (data['cart-icon-bubble']) {
      const t = document.createElement('div');
      t.innerHTML = data['cart-icon-bubble'];
      const inc = t.querySelector('#cart-icon-bubble') || t.querySelector('[id^="CartCount"]') || t.firstElementChild;
      const cur = document.querySelector('#cart-icon-bubble')   || document.querySelector('[id^="CartCount"]');
      if (inc && cur) cur.replaceWith(inc);
    }

    document.querySelector('cart-drawer')?.open?.();
    clearErrors();
  }

  async function addWarranty() {
    const res = await fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: WARRANTY_VARIANT_ID, quantity: 1 }),
      cache: 'no-store'
    });
    if (!res.ok) {
      try { const d = await res.json(); throw new Error(d?.description || d?.message || `HTTP ${res.status}`); }
      catch { throw new Error(`HTTP ${res.status}`); }
    }
  }

  async function changeLine(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line, quantity }),
      cache: 'no-store'
    });
    if (!res.ok) throw new Error('change failed');
  }

  // EN delegating-lyssnare som täcker allt i drawern:
  document.body.addEventListener('click', async (e) => {
    // 1) Lägg till garanti (drawer)
    const addWarrantyBtn = e.target.closest('.js-add-warranty-drawer');
    if (addWarrantyBtn) {
      e.preventDefault(); e.stopPropagation();
      clearErrors(); addWarrantyBtn.disabled = true;
      try { await addWarranty(); await refreshDrawer(); }
      catch (err) { console.error(err); setError('Det uppstod ett fel när din kundvagn skulle uppdateras. Var god försök igen.'); }
      finally { addWarrantyBtn.disabled = false; }
      return;
    }

    // 2) + / – i drawer
    const qtyBtn = e.target.closest('cart-drawer .quantity__button');
    if (qtyBtn) {
      e.preventDefault(); e.stopPropagation();
      clearErrors();
      try {
        const qtyWrap = qtyBtn.closest('.quantity');
        const input   = qtyWrap?.querySelector('.quantity__input');
        const line    = Number(input?.dataset.index);
        let   qty     = Number(input?.value || 0);
        if (qtyBtn.name === 'plus') qty += 1; else qty = Math.max(0, qty - 1);
        await changeLine(line, qty);
        await refreshDrawer();
      } catch (err) {
        console.error(err); setError('Det uppstod ett fel när din kundvagn skulle uppdateras. Var god försök igen.');
      }
      return;
    }

    // 3) Ta bort i drawer (papperskorg)
    const removeBtn = e.target.closest('cart-drawer .drawer__cart-remove-button');
    if (removeBtn) {
      e.preventDefault(); e.stopPropagation();
      clearErrors();
      try {
        const input = removeBtn.closest('.drawer__cart-item')?.querySelector('.quantity__input');
        const line  = Number(input?.dataset.index);
        await changeLine(line, 0);
        await refreshDrawer();
      } catch (err) {
        console.error(err); setError('Det uppstod ett fel när din kundvagn skulle uppdateras. Var god försök igen.');
      }
    }
  });

  // OBS: Kassasidan ( /cart ) har sin egen knapp .js-add-warranty-cart – låt den
  // fortsätta använda ditt befintliga block (eller kopiera addWarranty()+section-refresh dit).
})();
